import { defineStore } from "pinia";
import { ref } from "vue";

export const useTypeSexStore = defineStore("typeSex", () => {
  const sexo = ref([
    { id: "F", nombre: "Femenino" },
    { id: "M", nombre: "Masculino" },
  ]);

  const getAll = () => sexo.value;

  const getByNombre = (nombre) => {
    if (!nombre) return null;

    const sexoFounded = sexo.value.find((n) => n.nombre.toUpperCase() === nombre.toUpperCase());

    return sexoFounded ? sexoFounded.id : null;
  };

  return {
    sexo,
    getAll,
    getByNombre,
  };
});
